import { create } from "zustand";
import type { Agent } from "@rwasupport/shared";

type AuthState = {
  agent: Agent | null;
  status: "idle" | "loading" | "authenticated" | "unauthenticated";
  setAgent: (agent: Agent | null) => void;
  setStatus: (status: AuthState["status"]) => void;
  reset: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  agent: null,
  status: "idle",
  setAgent: (agent) =>
    set({
      agent,
      status: agent ? "authenticated" : "unauthenticated"
    }),
  setStatus: (status) => set({ status }),
  reset: () =>
    set({
      agent: null,
      status: "unauthenticated"
    })
}));
